var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbsenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FF0000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8672 25.0118C23.0947 25.0118 23.3129 24.9215 23.4738 24.7606C23.6347 24.5997 23.725 24.3815 23.725 24.154V23.0852C23.7285 20.6781 20.3161 18.7926 16.8625 18.7926C13.4089 18.7926 9.99994 20.6781 9.99994 23.0852V24.154C9.99994 24.3815 10.0903 24.5997 10.2512 24.7606C10.4121 24.9215 10.6303 25.0118 10.8578 25.0118H22.8672ZM19.9541 13.0916C19.9541 13.4976 19.8741 13.8996 19.7187 14.2747C19.5634 14.6498 19.3357 14.9906 19.0486 15.2777C18.7615 15.5647 18.4207 15.7925 18.0456 15.9478C17.6705 16.1032 17.2685 16.1832 16.8625 16.1832C16.4565 16.1832 16.0545 16.1032 15.6794 15.9478C15.3043 15.7925 14.9635 15.5647 14.6764 15.2777C14.3893 14.9906 14.1616 14.6498 14.0062 14.2747C13.8509 13.8996 13.7709 13.4976 13.7709 13.0916C13.7709 12.2716 14.0966 11.4853 14.6764 10.9055C15.2562 10.3257 16.0426 10 16.8625 10C17.6824 10 18.4688 10.3257 19.0486 10.9055C19.6284 11.4853 19.9541 12.2716 19.9541 13.0916Z",
    stroke: "#FF0000",
    strokeWidth: 1.28673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 16.002L25.453 12.7M22.15 12.7L25.453 16.002",
    stroke: "#FF0000",
    strokeWidth: 0.700583,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsenceIcon);
export default __webpack_public_path__ + "static/media/AbsenceIcon.d5572a20d83c1a2dfcff6c5b94dc5784.svg";
export { ForwardRef as ReactComponent };